const currencies = [

  // ======================
  // EUROPE
  // ======================
  { value: "EUR", label: "€ - Euro" },
  { value: "BGN", label: "лв - Bulgarian Lev" },
  { value: "CZK", label: "Kč - Czech Koruna" },
  { value: "DKK", label: "kr - Danish Krone" },
  { value: "HUF", label: "Ft - Hungarian Forint" },
  { value: "PLN", label: "zł - Polish Złoty" },
  { value: "RON", label: "lei - Romanian Leu" },
  { value: "SEK", label: "kr - Swedish Krona" },
  { value: "CHF", label: "CHF - Swiss Franc" },
  { value: "ISK", label: "kr - Icelandic Króna" },
  { value: "NOK", label: "kr - Norwegian Krone" },
  { value: "GBP", label: "£ - British Pound Sterling" },
  { value: "ALL", label: "L - Albanian Lek" },
  { value: "BAM", label: "KM - Bosnia-Herzegovina Convertible Mark" },
  { value: "MKD", label: "ден - Macedonian Denar" },
  { value: "RSD", label: "дин - Serbian Dinar" },
  { value: "MDL", label: "L - Moldovan Leu" },
  { value: "UAH", label: "₴ - Ukrainian Hryvnia" },
  { value: "GEL", label: "₾ - Georgian Lari" },
  { value: "AMD", label: "֏ - Armenian Dram" },
  { value: "AZN", label: "₼ - Azerbaijani Manat" },
  { value: "EUR", label: "€ - Euro (Monaco, Vatican, San Marino, Andorra)" },
  { value: "GIP", label: "£ - Gibraltar Pound" },
  { value: "FKP", label: "£ - Falkland Islands Pound" },

  // ======================
  // AFRICA
  // ======================
  { value: "DZD", label: "د.ج - Algerian Dinar" },
  { value: "AOA", label: "Kz - Angolan Kwanza" },
  { value: "XOF", label: "CFA - West African CFA Franc" },
  { value: "XAF", label: "CFA - Central African CFA Franc" },
  { value: "BWP", label: "P - Botswanan Pula" },
  { value: "BIF", label: "FBu - Burundian Franc" },
  { value: "CVE", label: "$ - Cape Verdean Escudo" },
  { value: "CDF", label: "FC - Congolese Franc" },
  { value: "DJF", label: "Fdj - Djiboutian Franc" },
  { value: "EGP", label: "£ - Egyptian Pound" },
  { value: "ETB", label: "Br - Ethiopian Birr" },
  { value: "GHS", label: "₵ - Ghanaian Cedi" },
  { value: "GNF", label: "FG - Guinean Franc" },
  { value: "KES", label: "KSh - Kenyan Shilling" },
  { value: "MAD", label: "د.م. - Moroccan Dirham" },
  { value: "MZN", label: "MT - Mozambican Metical" },
  { value: "NGN", label: "₦ - Nigerian Naira" },
  { value: "RWF", label: "FRw - Rwandan Franc" },
  { value: "SCR", label: "₨ - Seychellois Rupee" },
  { value: "SLL", label: "Le - Sierra Leonean Leone" },
  { value: "SOS", label: "Sh - Somali Shilling" },
  { value: "ZAR", label: "R - South African Rand" },
  { value: "TND", label: "د.ت - Tunisian Dinar" },
  { value: "UGX", label: "USh - Ugandan Shilling" },
  { value: "ZMW", label: "ZK - Zambian Kwacha" },

  // ======================
  // ASIA
  // ======================
  { value: "AED", label: "د.إ - UAE Dirham" },
  { value: "AFN", label: "؋ - Afghan Afghani" },
  { value: "BHD", label: ".د.ب - Bahraini Dinar" },
  { value: "BDT", label: "৳ - Bangladeshi Taka" },
  { value: "BTN", label: "Nu. - Bhutanese Ngultrum" },
  { value: "CNY", label: "¥ - Chinese Yuan" },
  { value: "HKD", label: "$ - Hong Kong Dollar" },
  { value: "IDR", label: "Rp - Indonesian Rupiah" },
  { value: "ILS", label: "₪ - Israeli New Shekel" },
  { value: "INR", label: "₹ - Indian Rupee" },
  { value: "IQD", label: "ع.د - Iraqi Dinar" },
  { value: "IRR", label: "﷼ - Iranian Rial" },
  { value: "JPY", label: "¥ - Japanese Yen" },
  { value: "KHR", label: "៛ - Cambodian Riel" },
  { value: "KRW", label: "₩ - South Korean Won" },
  { value: "KWD", label: "د.ك - Kuwaiti Dinar" },
  { value: "KZT", label: "₸ - Kazakhstani Tenge" },
  { value: "LAK", label: "₭ - Laotian Kip" },
  { value: "LKR", label: "Rs - Sri Lankan Rupee" },
  { value: "MMK", label: "Ks - Myanmar Kyat" },
  { value: "MNT", label: "₮ - Mongolian Tögrög" },
  { value: "MYR", label: "RM - Malaysian Ringgit" },
  { value: "NPR", label: "Rs - Nepalese Rupee" },
  { value: "OMR", label: "ر.ع. - Omani Rial" },
  { value: "PHP", label: "₱ - Philippine Peso" },
  { value: "PKR", label: "Rs - Pakistani Rupee" },
  { value: "QAR", label: "ر.ق - Qatari Riyal" },
  { value: "SAR", label: "ر.س - Saudi Riyal" },
  { value: "SGD", label: "$ - Singapore Dollar" },
  { value: "THB", label: "฿ - Thai Baht" },
  { value: "TRY", label: "₺ - Turkish Lira" },
  { value: "TWD", label: "$ - New Taiwan Dollar" },
  { value: "VND", label: "₫ - Vietnamese Đồng" },

  // ======================
  // AMERICAS
  // ======================
  { value: "ARS", label: "$ - Argentine Peso" },
  { value: "BOB", label: "Bs. - Bolivian Boliviano" },
  { value: "BRL", label: "R$ - Brazilian Real" },
  { value: "CAD", label: "$ - Canadian Dollar" },
  { value: "CLP", label: "$ - Chilean Peso" },
  { value: "COP", label: "$ - Colombian Peso" },
  { value: "CRC", label: "₡ - Costa Rican Colón" },
  { value: "CUP", label: "$ - Cuban Peso" },
  { value: "DOP", label: "RD$ - Dominican Peso" },
  { value: "GTQ", label: "Q - Guatemalan Quetzal" },
  { value: "HNL", label: "L - Honduran Lempira" },
  { value: "JMD", label: "J$ - Jamaican Dollar" },
  { value: "MXN", label: "$ - Mexican Peso" },
  { value: "NIO", label: "C$ - Nicaraguan Córdoba" },
  { value: "PEN", label: "S/ - Peruvian Sol" },
  { value: "PYG", label: "₲ - Paraguayan Guaraní" },
  { value: "USD", label: "$ - United States Dollar" },
  { value: "UYU", label: "$U - Uruguayan Peso" },
  { value: "VES", label: "Bs. - Venezuelan Bolívar" },

  // ======================
  // OCEANIA
  // ======================
  { value: "AUD", label: "$ - Australian Dollar" },
  { value: "FJD", label: "$ - Fijian Dollar" },
  { value: "NZD", label: "$ - New Zealand Dollar" },
  { value: "PGK", label: "K - Papua New Guinean Kina" },
  { value: "SBD", label: "$ - Solomon Islands Dollar" },
  { value: "TOP", label: "T$ - Tongan Paʻanga" },
  { value: "VUV", label: "VT - Vanuatu Vatu" }
];

export default currencies;
